/*eslint-disable */
export default {
  service: {
    game: {
      name: 'Dịch Vụ Game',
      description: 'Dịch Vụ Game'
    },
    stream: {
      name: 'Dịch Vụ Stream',
      description: 'Dịch Vụ Stream'
    },
    user: {
      name: 'Dịch Vụ Người Dùng',
      description: 'Dịch Vụ Người Dùng'
    },
    admin: {
      name: 'Dịch Vụ Quản Trị',
      description: 'Dịch Vụ Quản Trị'
    },
    wallet: {
      name: 'Dịch Vụ Ví',
      description: 'Dịch Vụ Ví'
    },
    setting: {
      name: 'Cài Đặt',
      description: 'Cài Đặt'
    },
    login: {
      logout: 'Đăng Xuát'
    }
  },
  stream: {
    order: {
      title: 'Order Detail Management'
    },
    user_management: {
      title: 'User Management'
    },
    scenario: {
      title: 'Scenario Management'
    },
    contact: {
      title: 'Contact Management',
    },
    admin_user: {
      title: 'Admin Management',
      package: 'Package Management',
      organization: 'Organization Management',
      admin_user_list: 'Admin Management'
    },
    report: {
      title: 'Report Management',
      outbound: 'Outbound Report',
      inbound: 'Inbound Report'
    },
    provider: {
      title: 'Provider Management',
      outbound: 'Outbound Management',
      inbound: 'Inbound Management'
    },
    incall: {
      title: 'InCall Management'
    },
    campaign: {
      title: 'Campaign Management',
      button: {
        uploadFile: 'Upload File',
        inactive: 'Inactive',
        active: 'Active'
      },
      table: {
        stt: 'stt',
        link: 'Link Download',
        status: 'Status',
        version: 'Version',
        operation: 'Action'
      }
    },
  },
  alert: {
    roleButton: "Don't Right"
  }
}
